import { render, staticRenderFns } from "./MyProjects.vue?vue&type=template&id=88f0a23e&"
import script from "./MyProjects.vue?vue&type=script&lang=js&"
export * from "./MyProjects.vue?vue&type=script&lang=js&"
import style0 from "./MyProjects.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports